<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size"
        :required="required"
        :translatable="translatable"
        :errors="errors"
        :hide-validation="!showValidation">
        <template #default>
            <input
                ref="input"
                v-model="model"
                class="form-control"
                type="text"
                autocomplete="off"
                autocapitalize="none"
                spellcheck="false"
                :class="inputClass"
                :name="name"
                :required="required"
                v-bind="$attrs">
        </template>

        <template #tips>
            <slot />
        </template>
    </FormGroup>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';

export default {
    name: 'TextField',

    components: {FormGroup},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {type: String, default: null},
    },

    computed: {
        length() {
            return String(this.value || '').length;
        },
    },
};
</script>
